import React, { useEffect, useState } from 'react'
import Header from '../../components/Header'
import { authAxios } from '../../helpers/axios'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import TabGroup from '../../components/TabGroup'
import { ErrorToast, InfoToast } from '../../helpers/toasters'
import { findCountryByCode } from '../../helpers/utils'
import ManageSupplier from './components/ManageTea'
import ManageTea from './components/ManageTea'
import CompleteBlend from './components/CompleteBlend'
import EditBlendTea from './components/EditBlendTea'
import DeleteBlendTea from './components/DeleteBlendTea'

export default function BlendedTeaInfo() {

    const {id} = useParams();
    const [gardenInfo,setGardenInfo] = useState([])
    const [showEdit,setShowEdit] = useState(false)
    const [showDelete,setShowDelete] = useState(false)
    const [activeTab,setActiveTab] = useState('orders')
    const [showComplete,setShowComplete] = useState(false)
    const navigate=  useNavigate()
    const [showAddProduct,setShowAddProduct] = useState({status:false,edit:false})

    const RightContent = ()=>
    {
        return <div className='flex flex-row gap-x-3'>
            <button type='button' className='btn-md text-xs font-semibold mr-4' onClick={()=>handlePrint()}>Print</button>

        {gardenInfo.productionBlends && gardenInfo.productionBlends.length < 1 ? <button type='button' className='btn-md text-xs font-bold bg-[#b03333] hover:bg-[#b00000] mr-2' onClick={()=>setShowDelete(true)}>Delete Blend</button> : null}
        <button type='button' className='btn-md text-xs font-semibold' onClick={()=>setShowEdit(true)}>Edit Blend</button>

        {gardenInfo.status === 1 || gardenInfo.status === '1' ? <button type='button' className='btn-md text-xs font-semibold' onClick={()=>setShowComplete(true)}>Complete Blend</button> : null}
        </div>
    }
    const handlePrint = () => {
        const printContents = document.getElementById('printable-content').innerHTML;
        const originalTitle = document.title;
        document.title = `#${gardenInfo.batchNumber} ${gardenInfo.blendName ? `(${gardenInfo.blendName})` : ''}`;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        const style = document.createElement('style');
        style.innerHTML = `@page { size: A4; margin: 0; } body { font-size: 16px; margin: 0; }`;
        document.head.appendChild(style);
        window.print();
        document.body.innerHTML = originalContents;
        document.title = originalTitle;
        window.location.reload();
    }

    async function getGardenInfo(){

        try 
        {
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/blend/${id}?populate=true`)
            setGardenInfo(res.data)
        } catch (error) {
            toast('Error getting Blend Tea')
        }
    }
    useEffect(()=>
    {
        getGardenInfo();
    },[])

    const onSubmit = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/blend/${id}`,data); 
            await getGardenInfo()
            setShowEdit(false)
            InfoToast('Garden Updated')
        } catch (error) {
            console.log(error)
            ErrorToast(error.response)
        }
    }

    const onDelete = async(e)=>
    {
        try 
        {
            e.preventDefault()
            let res = await authAxios.delete(`${process.env.REACT_APP_BASE_URL}/blend/${id}`); 
            navigate('/blended-tea')
            InfoToast('Blend Deleted')
        } catch (error) {
            ErrorToast(error.response)
        }
    }

    const onUpdate = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/blend/${id}`,data); 
            await getGardenInfo()
            setShowEdit(false)
            InfoToast('Blend Updated')
        } catch (error) {
            console.log(error)
            ErrorToast(error.response?.data?.error)
        }
    }

    const onComplete = async(e,blendWeight,warehouseId)=>
        {
            try 
            {
                e.preventDefault()
                let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/blend/complete/${id}`,{blendWeight:blendWeight,warehouseId:warehouseId}); 
                setShowComplete(false)
                await getGardenInfo()
                InfoToast('Blend Completed')
            } catch (error) {
                ErrorToast(error.response.data.error)
            }
        }

  return (
    <div className='h-screen flex flex-col items-stretch'>
        <div className='flex flex-col flex-1 h-full bg-white w-full'>
        <Header parentTitle='Blended Tea' parentLink='./blended-tea' title={`#${gardenInfo.batchNumber} ${gardenInfo.blendName ? `(${gardenInfo.blendName})` : ''}`} RightContent={RightContent}/>
        </div>
        <div id='printable-content' className='overflow-y-scroll flex-auto h-full'>
            <div className='flex flex-col flex-1 h-full bg-white w-full '>
            <div className=' justify-start items-start w-full py-12 px-6'>
            <div className='grid grid-cols-3 gap-6 w-full'>
                <div>
                    <label>Total Raw Tea Weight</label>
                    <p className='text-sm font-medium'>{gardenInfo?.totalWeight ? gardenInfo?.totalWeight : 'N/A'}</p>
                </div>
                <div>
                    <label>Total Raw Tea Bags</label>
                    <p className='text-sm font-medium'>{gardenInfo?.bags ? gardenInfo?.bags : 'N/A'}</p>
                </div>
                <div>
                    <label>Total Blend Tea Weight</label>
                    <p className='text-sm font-medium'>{gardenInfo?.blendWeight ? `${gardenInfo?.blendWeight} Kg` : 'N/A'}</p>
                </div>
                <div>
                    <label>Total Blend Tea Remaining</label>
                    <p className='text-sm font-medium'>{gardenInfo?.remainingWeight} Kg</p>
                </div>
                <div>
                    <label>Status</label>
                    <p className='text-sm font-medium'>{gardenInfo?.status === 1 ? 'Created' : gardenInfo.status === 2 ? 'Initiated' : gardenInfo.status === 3 ? 'Blended' : 'Stored'}</p> 
                </div>
                <div>
                    <label>Warehouse</label>
                    <p className='text-sm font-medium'>{gardenInfo?.warehouseId ? gardenInfo?.warehouse?.name : 'N/A'}</p> 
                </div>
                <div>
                    <label>Blend Leftover Cost</label>
                    <p className='text-sm font-medium'>Rs.{gardenInfo?.blendLeftoverCost ? parseInt(gardenInfo?.blendLeftoverCost) : 'N/A'}</p> 
                </div>
                <div>
                    <label>Blend Material Cost</label>
                    <p className='text-sm font-medium'>Rs.{gardenInfo?.blendMaterialCost ? parseInt(gardenInfo?.blendMaterialCost) : 'N/A'}</p> 
                </div>
                <div>
                    <label>Total Cost</label>
                    <p className='text-sm font-medium'>Rs.{gardenInfo?.blendMaterialCost ? parseInt(gardenInfo?.blendMaterialCost) + parseInt(gardenInfo?.blendLeftoverCost) : 'N/A'}</p> 
                </div>
                <div>
                    <label>Sales Order ID</label>
                    <p className='text-sm font-medium'>#{gardenInfo?.salesOrder?.orderId ? gardenInfo?.salesOrder?.orderId : 'N/A'}</p> 
                </div>
                <div>
                    <label>Buyer</label>
                    <p className='text-sm font-medium'>{gardenInfo?.salesOrder?.buyer?.name ? gardenInfo?.salesOrder?.buyer?.name : 'N/A'}</p> 
                </div>
            </div>
        </div>
        <div>
            <table>
                <thead>
                    <tr>
                        <th>Tea Invoice #</th>
                        <th>Garden Name</th>
                        <th>Bag Weight</th>
                        <th>Bags</th>
                        <th>Total Weight</th>
                    </tr>
                </thead>
                <tbody>
                    {gardenInfo?.blendmaterials?.map((tea,index)=>
                    <tr>
                        <td className='text-sm font-medium'>{tea?.blendRawTeaBag?.tea?.invoiceNumber}</td>
                        <td className='text-sm font-medium'>{tea?.blendRawTeaBag?.tea?.garden?.name}</td>
                        <td className='text-sm font-medium'>{tea?.netWeight/tea?.bags}</td>
                        <td className='text-sm font-medium'>{tea?.bags}</td>
                        <td className='text-sm font-medium'>{tea?.netWeight}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>
        
        
        {gardenInfo.blendLeftoverMaterial ? <div className='mt-12'>
            <div className='px-6 mb-6'>
            <p className='text-sm font-medium underline'>Blend Leftovers Used</p>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Batch Number #</th>
                        <th>Blend Name</th>
                        <th>Blend's Weight Used</th>
                        <th>Blend's Total Weight</th>
                    </tr>
                </thead>
                <tbody>
                    {gardenInfo?.blendLeftoverMaterial?.map((tea,index)=>
                    <tr>
                        <td className='text-sm font-medium'>{tea?.blendUsed?.batchNumber}</td>
                        <td className='text-sm font-medium'>{tea?.blendUsed?.blendName ? tea?.blendUsed?.blendName : 'N/A'}</td>
                        <td className='text-sm font-medium'>{tea?.totalWeight}</td>
                        <td className='text-sm font-medium'>{tea?.blendUsed?.totalWeight}</td>
                    </tr>)}
                </tbody>
            </table>
        </div> : null}
        
        {gardenInfo.productionBlends && gardenInfo.productionBlends.length > 0 ? <div className='mt-12'>
            <div className='px-6 mb-6'>
            <p className='text-sm font-medium underline'>Production Orders used this Blend</p>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Sales Order ID</th>
                        <th>Buyer</th>
                        <th>Blend Used</th>
                        <th>Blend Remaining</th>
                        <th>Reverted Blend</th>
                    </tr>
                </thead>
                <tbody>
                    {gardenInfo?.productionBlends?.map((blend,index)=>
                    <tr>
                        <td className='text-sm font-medium'>#{blend?.productionOrder?.salesOrder?.orderId}</td>
                        <td className='text-sm font-medium'>{blend?.productionOrder?.salesOrder?.buyer?.name ? blend?.productionOrder?.salesOrder?.buyer?.name : 'N/A'}</td>
                        <td className='text-sm font-medium'>{blend?.weightUsed} Kg</td>
                        <td className='text-sm font-medium'>{blend?.weightRemaining} Kg</td>
                        <td className='text-sm font-medium'>{blend?.revertedWeight > 0 ? `${blend?.revertedWeight} Kg` : 'N/A'}</td>
                    </tr>)}
                </tbody>
            </table>
        </div> : null}


        </div>
        </div>
        { showEdit ? <EditBlendTea id={id} onClose={setShowEdit} onSubmit={onUpdate} edit={true} updateData={gardenInfo}/> : null}
        { showDelete ? <DeleteBlendTea id={id} onClose={setShowDelete} onSubmit={onDelete} updateData={gardenInfo}/> : null}
        { showComplete ? <CompleteBlend onClose={setShowComplete} setShow={setShowComplete} onSubmit={onComplete} updateData={gardenInfo}/> : null}
    </div>
  )
}
